import React, { useState } from "react"
import { useFider } from "@fider/hooks"
import { classSet, activateI18N } from "@fider/services"

// Tùy biến KHCN: đổi ngôn ngữ NGAY tại client (không tải lại trang) cho mượt và nhanh.
// - Vẫn gọi server để lưu cookie fider_locale (HttpOnly) → lần tải trang sau nhớ lựa chọn.
// - Vẫn để href thật làm phương án dự phòng khi JS lỗi/tắt (tải lại trang như cũ).
const LOCALES: { code: string; label: string; title: string }[] = [
  { code: "vi", label: "VI", title: "Tiếng Việt" },
  { code: "en", label: "EN", title: "English" },
]

const buildHref = (code: string): string => {
  const redirect = typeof window !== "undefined" ? `${window.location.pathname}${window.location.search}` : "/"
  return `/locale/${code}?redirect=${encodeURIComponent(redirect)}`
}

export const LocaleSwitcher = () => {
  const fider = useFider()
  const [current, setCurrent] = useState(fider.currentLocale)
  const [busy, setBusy] = useState(false)

  const switchLocale = async (e: React.MouseEvent, code: string, href: string) => {
    e.preventDefault()
    if (code === current || busy) {
      return
    }
    setBusy(true)
    try {
      // Lưu lựa chọn phía server (cookie HttpOnly) mà không tải lại trang.
      await fetch(href, { credentials: "include", redirect: "manual" })
      // Nạp + kích hoạt gói ngôn ngữ ở client; I18nProvider tự render lại toàn bộ cây.
      await activateI18N(code)
      // Đồng bộ để các chỗ định dạng ngày/giờ theo currentLocale cũng đổi theo.
      if (fider.settings) {
        fider.settings.locale = code
      }
      if (typeof document !== "undefined") {
        document.documentElement.lang = code
      }
      setCurrent(code)
    } catch {
      // Có sự cố thì quay về cách cũ: tải lại trang qua href.
      window.location.href = href
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="c-locale-switcher" role="group" aria-label="Language">
      {LOCALES.map((locale) => {
        const href = buildHref(locale.code)
        return (
          <a
            key={locale.code}
            href={href}
            title={locale.title}
            lang={locale.code}
            aria-current={current === locale.code ? "true" : undefined}
            aria-busy={busy ? "true" : undefined}
            onClick={(e) => switchLocale(e, locale.code, href)}
            className={classSet({ "c-locale-switcher__option": true, "c-locale-switcher__option--active": current === locale.code })}
          >
            {locale.label}
          </a>
        )
      })}
    </div>
  )
}
